(function() { module.exports = window["ItemsViewStrings"]; }());